import axios from "axios";

const deassignDimensionItem = (company_id, vendor_id, dimension_item_id) => {
  return axios.delete(
    `/api/v1/companies/${company_id}/vendor_dimension_items/${dimension_item_id}/${vendor_id}`,
  );
};

const assignDimensionItem = (company_id, vendor_id, dimension_item_id) => {
  return axios.post(
    `/api/v1/companies/${company_id}/vendor_dimension_items/${dimension_item_id}/${vendor_id}`,
  );
};

const fetchDimensionItems = (company_id, vendor_id, params, config) => {
  return axios.get(
    `/api/v1/companies/${company_id}/vendor_dimension_items/${vendor_id}`,
    { params, ...config },
  );
};

const vendorDimensionItems = (company_id, vendor_id, params, config) => {
  return axios.get(
    `/api/v1/companies/${company_id}/vendor_dimension_items/${vendor_id}/dimension_items`,
    { params, ...config },
  );
};

const updateVendorDimensionItem = (
  company_id,
  vendor_dimension_item_id,
  vendor_dimension_item,
) => {
  return axios.patch(
    `/api/v1/companies/${company_id}/vendor_dimension_items/${vendor_dimension_item_id}`,
    vendor_dimension_item,
  );
};

const ApiVendorDimensionItems = {
  deassignDimensionItem,
  assignDimensionItem,
  fetchDimensionItems,
  vendorDimensionItems,
  updateVendorDimensionItem,
};

export default ApiVendorDimensionItems;
